'use client';

import { ContactInfo } from '../lib/types';

interface Step4LeadCaptureProps {
  domain: string;
  contact: ContactInfo;
  onChange: (contact: ContactInfo) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function Step4LeadCapture({
  domain,
  contact,
  onChange,
  onNext,
  onBack,
}: Step4LeadCaptureProps) {
  const canProceed =
    contact.fullName.trim().length >= 2 &&
    contact.email.includes('@') &&
    contact.phone.trim().length >= 8;

  return (
    <div className="animate-fade-in max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-2">Vos coordonnées</h2>
      <p className="text-muted mb-2">
        Pour recevoir votre simulation personnalisée pour{' '}
        <span className="font-mono text-primary font-medium">{domain}</span>
      </p>
      <p className="text-xs text-muted mb-8">
        Nous vous enverrons les résultats de votre configuration par email.
      </p>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium mb-1.5">
            Nom complet <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            value={contact.fullName}
            onChange={(e) => onChange({ ...contact, fullName: e.target.value })}
            placeholder="Ex: Jean Koffi"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">
            Email <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            value={contact.email}
            onChange={(e) => onChange({ ...contact, email: e.target.value })}
            placeholder="Ex: jean@gmail.com"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">
            WhatsApp / Téléphone <span className="text-danger">*</span>
          </label>
          <input
            type="tel"
            value={contact.phone}
            onChange={(e) => onChange({ ...contact, phone: e.target.value })}
            placeholder="Ex: +229 97 00 00 00"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
          />
        </div>
      </div>

      <div className="mt-6 bg-primary-light/50 rounded-lg p-4">
        <div className="flex items-start gap-2.5">
          <span className="text-primary mt-0.5 shrink-0">&#9432;</span>
          <p className="text-xs text-primary/80">
            Vos informations sont sécurisées et ne seront utilisées que pour vous envoyer
            votre simulation et vous accompagner dans la mise en place de vos emails.
          </p>
        </div>
      </div>

      <div className="flex gap-3 mt-8">
        <button
          onClick={onBack}
          className="px-6 py-3 rounded-lg border border-border text-muted hover:bg-gray-50 transition-colors cursor-pointer"
        >
          Retour
        </button>
        <button
          onClick={onNext}
          disabled={!canProceed}
          className="flex-1 bg-primary hover:bg-primary-hover disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg transition-colors cursor-pointer"
        >
          Configurer mes emails
        </button>
      </div>
    </div>
  );
}